/* Stig Gateway — intro orchestration, matrix rain, typewriter.
   Everything degrades: reduced-motion users skip straight to the full
   terminal; no-JS visitors get the static fallback line + buttons (CSS). */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var intro = document.getElementById('stigIntro');
  var monitor = document.getElementById('stigMonitor');
  var typed = document.getElementById('stigTyped');
  var cur = document.getElementById('stigCur');
  var choices = document.getElementById('stigChoices');
  var canvas = document.getElementById('stigRain');
  if (!monitor || !typed) return;

  var LINES = [
    'INCOMING TRANSMISSION . . .',
    '',
    'HELLO, STIG.',
    'WE HAVE BEEN EXPECTING YOU.',
    '',
    'TONIGHT, A DECISION AWAITS.',
    '',
    'SELECT ONE, STIG:'
  ];

  /* ---------- intro: bouncing STIG, skippable, ~3.6s ---------- */
  var started = false;
  function endIntro() {
    if (started) return;
    started = true;
    document.removeEventListener('pointerdown', endIntro, true);
    document.removeEventListener('keydown', endIntro, true);
    if (intro) {
      intro.classList.add('out');
      setTimeout(function () { intro.remove(); }, 500);
    }
    monitor.classList.add('live');
    if (!reduce) startRain();
    setTimeout(typeNext, reduce ? 0 : 650);
  }

  if (reduce || !intro) {
    if (intro) intro.remove();
    endIntro();
  } else {
    document.addEventListener('pointerdown', endIntro, true);
    document.addEventListener('keydown', endIntro, true);
    setTimeout(endIntro, 3600);
  }

  /* ---------- typewriter ---------- */
  var li = 0, ci = 0;
  function typeNext() {
    if (reduce) {
      typed.textContent = LINES.map(function (l) { return l ? '> ' + l : ''; }).join('\n');
      reveal();
      return;
    }
    cur.hidden = false;
    if (li >= LINES.length) { reveal(); return; }
    var line = LINES[li];
    if (ci === 0) {
      if (li > 0) typed.textContent += '\n';
      if (line) typed.textContent += '> ';
    }
    if (ci < line.length) {
      typed.textContent += line.charAt(ci);
      ci++;
      setTimeout(typeNext, 18 + Math.random() * 40);
    } else {
      li++; ci = 0;
      setTimeout(typeNext, line ? 300 : 110);
    }
  }

  function reveal() {
    if (choices) choices.classList.add('show');
  }

  /* ---------- matrix rain, throttled and cheap ---------- */
  function startRain() {
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var fs = 14, cols = 0, drops = [];
    var chars = 'アイウエオカキクケコサシスセソタチツテトナニヌネノ0123456789STIG*+=<>';

    function size() {
      var r = canvas.getBoundingClientRect();
      canvas.width = Math.max(1, r.width * dpr);
      canvas.height = Math.max(1, r.height * dpr);
      cols = Math.ceil(r.width / (fs * 0.62));
      drops = [];
      for (var i = 0; i < cols; i++) drops[i] = Math.random() * -40;
      ctx.fillStyle = '#010401';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    size();
    window.addEventListener('resize', size);

    var last = 0;
    function frame(ts) {
      if (ts - last > 70) {
        last = ts;
        ctx.fillStyle = 'rgba(1,4,1,0.16)';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.font = (fs * dpr) + 'px monospace';
        for (var i = 0; i < cols; i++) {
          var x = i * fs * 0.62 * dpr;
          var y = drops[i] * fs * dpr;
          ctx.fillStyle = Math.random() < 0.08 ? '#b7ffcb' : '#2f9c53';
          ctx.fillText(chars.charAt((Math.random() * chars.length) | 0), x, y);
          drops[i] += 0.8 + Math.random() * 0.6;
          if (y > canvas.height && Math.random() < 0.04) drops[i] = Math.random() * -20;
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
})();
